<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container">
      <router-link class="navbar-brand text-style" to="/"
        >Guitar Tab Pro</router-link
      >
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style scoped>
.text-style {
  font-size: 30px !important;
  font-family: "Lucida Console", Courier, monospace !important;
  color: #81D8D0 !important;
}
</style>
